import React, { PropsWithChildren } from 'react';
import { TextProps } from 'react-native';
import { AppText95 } from '@/components/AppText95';
import { StyleSheet } from 'react-native';
import * as AppConsts from '@/utilities/AppConsts';

const styles = StyleSheet.create({
  default: {
    fontSize: AppConsts.DEFAULT_FONT_SIZE,
    flexShrink: 1,
  },
});

export const AppTextStyles = StyleSheet.create({
  default: {
    ...styles.default,
  },
  tiny: {
    ...styles.default,
    fontSize: AppConsts.DEFAULT_FONT_SIZE - 5,
  },
  tinyItalics: {
    ...styles.default,
    fontSize: AppConsts.DEFAULT_FONT_SIZE - 5,
    fontStyle: "italic",
  },
  small: {
    ...styles.default,
    fontSize: AppConsts.DEFAULT_FONT_SIZE - 2,
  },
  medium: {
    ...styles.default,
    fontSize: AppConsts.DEFAULT_FONT_SIZE,
  },
  large: {
    ...styles.default,
    fontSize: AppConsts.DEFAULT_FONT_SIZE + 2,
  },
});

interface Props extends TextProps {
};

export function AppText({ children, ...props }: PropsWithChildren<Props>) : React.ReactNode {
  return (
    <AppText95 {...props}>
      { children }
    </AppText95>
  );
};
